var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('UserInterface2FolderDataTable',{staticClass:"mt-4",attrs:{"dataTableSearchTextFieldLabel":'Search Account Statistics'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }